export var BlockReasons;
(function(BlockReasons) {
    /** deviation is marked as mature and the user has the mature filter enabled */ BlockReasons["MatureFilter"] = "mature_filter";
    /** deviation is marked as mature and the user is underage */ BlockReasons["MatureAge"] = "mature_age";
    /** deviation is marked as strict mature and the user is underage */ BlockReasons["StrictMatureAge"] = "strict_mature_age";
    /** deviation is marked as mature and the user is logged out */ BlockReasons["MatureLoggedOut"] = "mature_loggedout";
    /** current user has blocked this deviation */ BlockReasons["DeviationBlocked"] = "deviation_blocked";
    /** current user has the artist of this deviation blocked */ BlockReasons["ArtistBlocked"] = "artist_blocked";
    /** the author of this deviation has blocked the current user */ BlockReasons["BlockedByArtist"] = "blocked_by_artist";
    /** the deviation is marked as antisocial and the user is logged out */ BlockReasons["Antisocial"] = "antisocial";
    /** deviation is marked as nsfg */ BlockReasons["Nsfg"] = "nsfg";
})(BlockReasons || (BlockReasons = {}));

//# sourceMappingURL=types.js.map